import I18n from 'I18n';
import { Select } from 'foundations-components/components/Select';
import { useCallback } from 'react';
import { useGetQueryParamWithArrays } from '../../../app/hooks/useGetQueryParam';
import { useSetQueryParams } from '../../../app/hooks/useSetQueryParams';
import { TrackingAction, TrackingFeature, TrackingScreen, trackUsage } from '../../../app/utils/tracking';
import { getTrackingSubscreenTab, excludeNullable } from '../../utils';

// If translationKey is provided, the optionTextValue is expected to be an array of strings or objects with a translationKey property.
import { jsx as _jsx } from "react/jsx-runtime";
export default function MultiSelectFilter({
  disabled,
  category,
  filterType,
  menuInlineSize,
  optionTextValue,
  translationKey,
  onChangeCB
}) {
  const queryParamValue = useGetQueryParamWithArrays(filterType);
  const value = Array.isArray(queryParamValue) ? queryParamValue : [queryParamValue].filter(excludeNullable);
  const setQueryParams = useSetQueryParams();
  const getSelectLabel = useCallback(() => I18n.text(`app.filters.${filterType}.label`, {
    count: value.length || 1
  }), [filterType, value.length]);
  const options = optionTextValue.map(option => {
    if (typeof option === 'string') {
      return {
        text: I18n.text(`${translationKey}.${option}`),
        value: option
      };
    }
    const translationNeeded = ('translationKey' in option);
    const optionKey = translationNeeded ? I18n.text(`${translationKey}.${option.translationKey}`) : option.text;
    return {
      text: optionKey,
      value: option.value
    };
  });
  return /*#__PURE__*/_jsx(Select, {
    disabled: disabled,
    menuInlineSize: menuInlineSize,
    multi: true,
    searchable: true,
    selectedItemsPlaceholder: getSelectLabel(),
    selectedValues: value,
    options: options,
    onSelectedOptionChange: ({
      selectedValues
    }) => {
      setQueryParams({
        [filterType]: selectedValues,
        offset: ''
      });
      trackUsage(TrackingScreen.PRODUCT_UPDATES, getTrackingSubscreenTab(category), TrackingFeature.MULTI_SELECT_FILTER, TrackingAction.CLICK);
      if (onChangeCB && typeof onChangeCB === 'function') {
        onChangeCB();
      }
    }
  });
}